import { FileText, Mail, MessageSquare, ShoppingBag, Megaphone, Film, Clapperboard, Video } from "lucide-react";

export const tplIcons = {
  blog_post: FileText,
  marketing_copy: Megaphone,
  product_description: ShoppingBag,
  social_media: MessageSquare,
  email_campaign: Mail,
  tiktok_script: Film,
  instagram_reel: Clapperboard,
  youtube_short: Video,
};
